import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';
import Button from '../Button';

const propTypes = {
  bubbleText: PropTypes.string,
  imageUrl: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.arrayOf(PropTypes.string),
  primaryButtonText: PropTypes.string,
  primaryButtonTo: PropTypes.string,
  primaryButtonOnClick: PropTypes.func,
  secondaryButtonText: PropTypes.string,
  secondaryButtonTo: PropTypes.string,
  secondaryButtonOnClick: PropTypes.func,
}

const Card = ({
  bubbleText,
  imageUrl,
  icon,
  title,
  subtitle = [],
  primaryButtonText,
  primaryButtonTo,
  primaryButtonOnClick,
  secondaryButtonText,
  secondaryButtonTo,
  secondaryButtonOnClick,
}) => (
  <div className={styles.container}>
    <div className={styles['image-container']}>
      {bubbleText && <div className={styles.bubble}>{bubbleText}</div>}
      <div className={styles.image} style={{backgroundImage: `url('${imageUrl}')`}} />
    </div>
    <div className={styles['text-container']}>
      <h5 className={styles.title}>{title}</h5>
      {subtitle.map(s => <p key={s} className={styles.subtitle}>{s}</p>)}
    </div>
    <div className={styles.actions}>
      {secondaryButtonText && (
        <Button
          buttonType="text"
          label={secondaryButtonText}
          to={secondaryButtonTo}
          onClick={secondaryButtonOnClick}
        />
      )}
      {primaryButtonText && (
        <Button
          buttonType="solid"
          label={primaryButtonText}
          color={'green'}
          to={primaryButtonTo}
          onClick={primaryButtonOnClick}
        />
      )}
    </div>
  </div>
);

Card.propTypes = propTypes;

export default Card;



// WEBPACK FOOTER //
// ./src/common/components/Card/index.js